import { ACPermissionResult } from './types';
import jwt_decode, { } from 'jwt-decode';





export function authorizeReadPermission(
  token,
  module,
)


 {
  const permissions = decodePermissionsFromToken(token);

  let authorizeResult = ACPermissionResult.DENY;
  let allowedResources = permissions.reduce((prev, cur) => {
    if (cur.module === module && cur.action.includes('read')) {
      authorizeResult = ACPermissionResult.ALLOW;

      if (cur.submodule && !prev.includes(cur.submodule)) {
        prev.push(cur.submodule);
      }
    }

    return prev;
  }, []);

  if (allowedResources.includes('*')) {
    allowedResources = ['*'];
  }

  return {
    authorizeResult,
    allowedResources,
  };
}

export function authorizeCreatePermission(token, module) {
  const permissions = decodePermissionsFromToken(token);
  return findPermission(module, 'create', permissions);
}

export function authorizeUpdatePermission(token, module) {
  const permissions = decodePermissionsFromToken(token);
  return findPermission(module, 'update', permissions);
}

export function authorizeDeletePermission(token, module) {
  const permissions = decodePermissionsFromToken(token);
  return findPermission(module, 'delete', permissions);
}

function decodePermissionsFromToken(token) {
  const decoded = jwt_decode(token);
  const permissions = decoded.permissions;

  if (!permissions) {
    return [];
  }

  return permissions;
}

function findPermission(
  module,
  action,
  permissions,
) {
  return permissions.some(
    cur => cur.module === module && cur.action.includes(action),
  )
    ? ACPermissionResult.ALLOW
    : ACPermissionResult.DENY;
}
